import { render, staticRenderFns } from "./ReceivedGiftCodesPanel.vue?vue&type=template&id=572b1784&"
import script from "./ReceivedGiftCodesPanel.vue?vue&type=script&lang=js&"
export * from "./ReceivedGiftCodesPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports